export function formatDeltaPct(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${value.toFixed(1)}%`;
}

export function formatDeltaAbsolute(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  const sign = value > 0 ? "+" : "";
  return `${sign}${Math.round(value).toLocaleString("en-CA")}`;
}

export type DeltaTone = "positive" | "negative" | "neutral";

export function deltaTone(delta: number | null | undefined): DeltaTone {
  if (delta == null || delta === 0) return "neutral";
  return delta > 0 ? "positive" : "negative";
}
